import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'cedato-publishers-report-all',
  templateUrl: './publishers-report-all.component.html',
  styleUrls: ['./publishers-report-all.component.scss'],
})
export class PublishersReportAllComponent {
  public selectedDimensions: Array<any> = [];
  public reportTabsData: Array<any>;

  constructor(
    public router: Router,
    public userService: UserService,
    public dictionaryService: DictionaryService,
    public ga: GoogleAnalyticsService
  ) {
    this.reportTabsData = [];
    if (
      this.userService.getFeatureState('publisher_hb') &&
      this.userService.userData.publisher_reportType &&
      +this.userService.userData.publisher_reportType === 3
    ) {
      this.reportTabsData = [
        { title: this.dictionaryService.get('OUTSTREAM'), key: 'out' },
        { title: this.dictionaryService.get('INSTREAM'), key: 'in' },
      ];
    }
    if (this.userService.userData && this.userService.userData.isHB) {
      this.selectedDimensions.push(3);
    } else {
      this.selectedDimensions.push(1);
    }
  }

  ngOnInit() {
    if (this.userService.userData.userType !== 'cedatopub') {
      this.router.navigate([this.userService.getDefaultRoute()]).then(() => {
        return;
      });
    }
  }

  ngOnDestroy() {}
}
